// frontend/src/fallbacks/umdGenEdAreas.ts
//
// Defensive UMD GE area fallback. The primary source is the backend
// /api/institution/current endpoint, fetched once at app init and exposed
// via InstitutionConfigContext. This file is consulted only when:
//   - the backend fetch fails AND no localStorage cache exists, OR
//   - the institution_config.gen_ed_areas row is empty for the current
//     institution (e.g. a new institution that hasn't been seeded yet)
//
// Keeping this list at a known path makes the SJSU pilot story work
// even in degraded states: the UI degrades to UMD's GE areas (still
// renders something) rather than crashing or showing an empty picker.
//
// Source of truth: database/migrations/025_institution_gen_ed_areas.sql.
// Keep this file in sync with that migration's UMD seed data — a quick
// audit script could automate this in a future iteration.

export interface GenEdArea {
  code: string;
  name: string;
  group: string;
}

export const UMD_GEN_ED_AREAS: GenEdArea[] = [
  { code: 'FSAW', name: 'Fundamental Studies - Academic Writing',          group: 'fundamental_studies' },
  { code: 'FSAR', name: 'Fundamental Studies - Analytic Reasoning',        group: 'fundamental_studies' },
  { code: 'FSMA', name: 'Fundamental Studies - Math',                      group: 'fundamental_studies' },
  { code: 'FSOC', name: 'Fundamental Studies - Oral Communication',        group: 'fundamental_studies' },
  { code: 'FSPW', name: 'Fundamental Studies - Professional Writing',      group: 'fundamental_studies' },
  { code: 'DSNL', name: 'Distributive Studies - Natural Sciences with Lab', group: 'distributive_studies' },
  { code: 'DSNS', name: 'Distributive Studies - Natural Sciences',         group: 'distributive_studies' },
  { code: 'DSHU', name: 'Distributive Studies - Humanities',               group: 'distributive_studies' },
  { code: 'DSHS', name: 'Distributive Studies - History & Social Sciences', group: 'distributive_studies' },
  { code: 'DSSP', name: 'Distributive Studies - Scholarship in Practice',  group: 'distributive_studies' },
  { code: 'DVUP', name: 'Diversity - Understanding Plural Societies',      group: 'diversity' },
  { code: 'DVCC', name: 'Diversity - Cultural Competence',                 group: 'diversity' },
  { code: 'SCIS', name: 'I-Series',                                        group: 'i_series' },
];
